document.addEventListener("DOMContentLoaded", function () {
  // Run only on homepage
  if (window.location.pathname !== "/") return;

  // Create snow container
  const snowContainer = document.createElement("div");
  snowContainer.classList.add("snow-container");
  document.body.appendChild(snowContainer);

  // Snowflake count
  const snowCount = 15;

  for (let i = 0; i < snowCount; i++) {
    let snow = document.createElement("div");
    snow.classList.add("snowflake");
    snow.style.left = Math.random() * 100 + "vw";
    snow.style.animationDuration = 5 + Math.random() * 5 + "s";
    snow.style.opacity = Math.random();
    snow.style.fontSize = Math.random() * 10 + 10 + "px";
    snow.innerHTML = "❄";
    snowContainer.appendChild(snow);
  }
});
